// extracted by mini-css-extract-plugin
export default {"container":"MaskTag_container__eFVBY","tagText":"MaskTag_tagText__hM+-u","blackText":"MaskTag_blackText__NVv5O","greyText":"MaskTag_greyText__60OLJ"};